import { Fragment, memo } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { SquareStackIcon, SwitchIcon, TrashIcon } from '@/icons';
import { QuestionCardAiMenu } from '../../features/question-card-ai/components/QuestionCardAiMenu';
import { useIsQuestionCardAiTarget } from '../../features/question-card-ai/hooks/useIsQuestionCardAiTarget';
import { useQuestionCardAiMenuItems } from '../../features/question-card-ai/hooks/useQuestionCardAiMenuItems';
import { useEditMode } from '../focus/useIsEditMode';
import { useQuizList } from '../useQuizList';
import { useMultipleOptions } from './Multiple/useMultipleOptions';
import { EditableHint } from './EditableHint';
import { EditTools } from './EditTools';
import { EditableMultiple } from './Multiple';
import { useQuizControl } from './QuizControlProvider';
export const MultipleBody = memo(({
  leftSlot
}: {
  leftSlot: React.ReactNode;
}) => {
  const {
    control,
    id,
    index
  } = useQuizControl();
  const {
    handleCopy,
    handleDelete
  } = useQuizList();
  const {
    t
  } = useTranslation(['common', 'build']);
  const {
    options,
    handleRemove,
    handleMove,
    handleInsert,
    handleAdd,
    handleShuffle
  } = useMultipleOptions({
    control,
    index
  });
  const {
    items: aiMenuItems,
    trackMenuOpen
  } = useQuestionCardAiMenuItems({
    quizId: id,
    quizIndex: index,
    place: 'mobile_drawer'
  });
  const isAiTarget = useIsQuestionCardAiTarget(id);
  const {
    isEditMode
  } = useEditMode();
  return <Fragment>
        <div className="flex flex-row justify-between" onClick={e => e.stopPropagation()}>
          {leftSlot}
          <div className="flex flex-row items-center gap-xs">
            {isEditMode && <>
                <EditTools.ChoiceRandomShuffleButton onClick={handleShuffle} />
                <EditTools.Divider className="hidden mobile-lg:flex" />
              </>}
            <QuestionCardAiMenu />
            <EditTools.QuizDuplicateButton />
            <EditTools.QuizDeleteButton />
            <EditTools.EditToolsDrawer onOpen={trackMenuOpen} tools={[...aiMenuItems.map(item => ({
          icon: item.icon,
          label: item.label,
          onClick: item.onSelect,
          disabled: item.disabled,
          description: item.reason
        })), {
          icon: <SquareStackIcon size="md" fill={ICON_COLOR.default} />,
          label: String(t('global.duplicate.button')),
          disabled: isAiTarget,
          onClick: () => handleCopy(index)
        }, {
          icon: <TrashIcon size="md" fill={ICON_COLOR.default} />,
          label: String(t('global.delete')),
          disabled: isAiTarget,
          onClick: () => {
            void handleDelete(index);
          }
        }, {
          icon: <SwitchIcon size="md" fill={ICON_COLOR.default} />,
          label: String(t('build:mixChoices')),
          onClick: handleShuffle
        }]} />
          </div>
        </div>

        <div className="flex flex-col justify-between gap-xs" onClick={e => e.stopPropagation()}>
          <EditableMultiple options={options} handleRemove={handleRemove} handleMove={handleMove} handleInsert={handleInsert} handleAdd={handleAdd} />
          <EditableHint />
        </div>
      </Fragment>;
});